import { createReducer } from '@reduxjs/toolkit';
import { SET_WIDGET } from '../constants/actionTypes';
import { WidgetState, Widget } from '../types';

export const widgetInitialState: WidgetState = {
  instance: undefined,
};

export const widget = createReducer(
  widgetInitialState,
  {
    [SET_WIDGET]: (
      state: WidgetState,
      resp: {
        payload: Widget;
      }
    ) => ({ instance: resp.payload })
  },
);
